import { useSelector } from "react-redux";
import { aboutEntityText } from "components/TechnicalView/AboutSidebar/AboutTexts";


	// Hook to generate about text to avoid complex and long inline turnary functions with a fallback 
	// text if hard-mapped data for region is not found
	const useGeneratedEntityAboutText = () =>{
	const { city_selected, tribe_selected, western_arizona_selected, is_tribe, is_city, is_western } =
		useSelector((state) => state.technical_view);

		let text = ""
		if(is_city){
		text = aboutEntityText['CITY'][city_selected.name] 
		}else if(is_tribe){
		text = aboutEntityText['TRIBE'][tribe_selected.name]
		}else if (is_western){
		text = aboutEntityText['WESTERN_AZ'][western_arizona_selected.name]
		}
		if(!text){
		return "Information coming soon..."
		}
		return text
	}

export default useGeneratedEntityAboutText